export class Script {
	public async: boolean = true;
	public loaded: boolean = false;
	public src: string = ""; // In case of external js file load (with path) eg: <script type="text/javascript" src="https://myexample.com/scripts.js"></script>
	public htmlScript: HTMLScriptElement = null; // The DOM element of <script></script> itself
	public location: string = "head"; // Injection place: head or body
	public locationType: string = "tag"; // We can inject the script in a location like <head> or <body> or inside an existing div (by ID).
	public type: string = "text/javascript"; // Other eg: "text/html"

	public constructor(public name: string) {}

	public fillHtmlModel(): void {
		if (!this.htmlScript) {
			this.htmlScript = document.createElement("script");
		} // Crash fallback

		this.htmlScript.type = this.type;
		this.htmlScript.async = this.async;

		if (this.src) {
			this.htmlScript.src = this.src;
		}
	}
}
